import { render, staticRenderFns } from "./EcGoods.vue?vue&type=template&id=3884366f&scoped=true&"
import script from "./EcGoods.vue?vue&type=script&lang=js&"
export * from "./EcGoods.vue?vue&type=script&lang=js&"
import style0 from "./EcGoods.vue?vue&type=style&index=0&id=3884366f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3884366f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
